import { Component, ViewChild, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import {
    createLocalAudioTrack, Room, LocalTrack, LocalVideoTrack, LocalAudioTrack, createLocalTracks, Participant, RemoteTrack,
    RemoteAudioTrack,
    RemoteVideoTrack,
    RemoteParticipant,
    RemoteTrackPublication
} from 'twilio-video';
import { VideoChatService } from '../services/videochat.service';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ActivatedRoute, Router } from '@angular/router';

import { PlatformLocation } from '@angular/common';
import { TalkToDoctorService } from 'src/app/api-services/talk-to-doctor.service';
import Swal from 'sweetalert2';
/**
 * This component use to connect video confenrence between doctor and patient.
 * For video,using twilio-video third party package to configure video chat/confernece room for creating.
 */
@Component({
    selector: 'app-chat',
    styleUrls: ['./chat.component.css'],
    templateUrl: './chat.component.html',
})
export class ChatComponent implements OnInit {
    // @ViewChild('participants') participants: ParticipantsComponent;
    @ViewChild('local') LocalVideo: ElementRef;
    @ViewChild('remote') remoteVideo: ElementRef;
    private Rparticipants: Map<Participant.SID, RemoteParticipant>;
    activeRoom: Room;
    isAudio: boolean = true;
    isVideo: boolean = true;
    private notificationHub: HubConnection;
    room: any = {};
    loader = true;
    participantName;
    showNote: boolean = false;
    notes: string;
    doctorappoint_id?
    constructor(
        private readonly videoChatService: VideoChatService, private activatedRoute: ActivatedRoute, public router: Router, public renderer: Renderer2, private location: PlatformLocation,
        private doctorservice: TalkToDoctorService) {
        location.onPopState(() => {
            this.onLeaveRoom(true);
        });

        this.room['roomName'] = this.activatedRoute.snapshot.queryParams.room;
        this.room['userName'] = this.activatedRoute.snapshot.queryParams.joiner;
        this.participantName = this.activatedRoute.snapshot.queryParams.participant

        if (this.participantName == 'doctor') {
            this.doctorappoint_id = this.activatedRoute.snapshot.queryParams.id
        }
    }

    
    ngOnInit() {
        this.room['roomName'] = this.activatedRoute.snapshot.queryParams.room;
        this.onRoom(this.room)

    }
    /**
     * To end up conference using this method.
     * To remove tracks, published participant information and disconnect video.
     */
    async onLeaveRoom(_: boolean) {
        this.room = {}
        if (this.activeRoom) {
            this.activeRoom.localParticipant.audioTracks.forEach(publication => {
                publication.track.stop();
                publication.unpublish();
            });
            this.activeRoom.localParticipant.videoTracks.forEach(publication => {
                publication.track.stop();
                publication.unpublish();
            });

            this.activeRoom.disconnect();
            this.activeRoom = null;
        }
        this.room = {}
        this.clear();
        (this.participantName == 'doctor') ? this.router.navigate(['/doctorappoinment-list']) : this.router.navigate(['/myappoinment'])

    }

    /**
     * This method to create video room for participants and set tracks.
     * @param roomName This param has participant room and user name
     * For creating room ,decalre different methods like tracks,participant publications
     * and intialize participants
     */

    async onRoom(roomName: any) {

        roomName = {
            roomName: this.room['roomName'],
            userName: this.room['userName']
        }

        if (roomName) {
            if (this.activeRoom) {
                this.activeRoom.disconnect();
            }
            const tracks = await createLocalTracks({ video: true, audio: true });
            this.activeRoom =
                await this.videoChatService
                    .joinOrCreateRoom(roomName.roomName, tracks, roomName.userName);

            this.initialize(this.activeRoom.participants)
            this.registerRoomEvents();
            this.activeRoom.localParticipant.tracks.forEach(localPublish => {
                this.attachLocalTrack(localPublish.track)
            })
        }
    };
    /**
     * This private method for attach local tracks like audio ,video
     * @param track this param has access local audio or video or data track
     */
    private attachLocalTrack(track: LocalTrack) {
        if (this.isAttachable(track)) {
            const element = track.attach(this.LocalVideo.nativeElement);
        }
    }
    /**
     * This method to verify tracks are avilable/enable from participant local device
     * @param track 
     * @returns 
     */
    private isAttachable(track: LocalTrack): track is LocalAudioTrack | LocalVideoTrack {
        return !!track
            && ((track as LocalAudioTrack).attach !== undefined
                || (track as LocalVideoTrack).attach !== undefined);
    }
    onParticipantsChanged(_: boolean) {
        this.videoChatService.nudge();
    }
    /**
     * This method to emit events like participants is connected or not
     */
    private async registerRoomEvents() {
        this.activeRoom
            .on('disconnected',
                (room: Room) => room.localParticipant.tracks.forEach(publication => {
                    this.detachLocalTrack(publication.track,)

                }))
            .on('participantConnected',
                (participant: RemoteParticipant) => this.add(participant))
            .on('participantDisconnected',
                (participant: RemoteParticipant) => this.remove(participant))
        // .on('dominantSpeakerChanged',
        //     (dominantSpeaker: RemoteParticipant) => this.participants.loudest(dominantSpeaker));
    }

    /**
     * This private method for detach(disable) local tracks like audio ,video
     * @param track 
     */
    private detachLocalTrack(track: LocalTrack) {
        if (this.isDetachable(track)) {
            track.detach().forEach(el => el.remove());
        }
    }

    /**
    * This method to verify tracks are avilable/enable from participant local device
    * @param track  This param has access local audio or video or data track
    * @returns 
    */
    private isDetachable(track: LocalTrack): track is LocalAudioTrack | LocalVideoTrack {
        return !!track
            && ((track as LocalAudioTrack).detach !== undefined
                || (track as LocalVideoTrack).detach !== undefined);
    }

    /**
     * Get input method for user selecting track like video/audio
     *  is on or off while conference going on
     * @param modes This param using to enable or disable tracks
     */
    getInputs(modes) {
        if (modes == 'audioOff') {
            this.activeRoom.localParticipant.audioTracks.forEach(publish => {
                publish.track.disable();
                this.isAudio = false
            })
        } else if (modes == 'audioOn') {
            this.activeRoom.localParticipant.audioTracks.forEach(publish => {
                publish.track.enable();

                this.isAudio = true;
            })
        } else if (modes == 'videoOn') {
            this.activeRoom.localParticipant.videoTracks.forEach(publish => {
                publish.track.disable();
                this.isVideo = false;
            })
        } else if (modes == 'videoOff') {
            this.activeRoom.localParticipant.videoTracks.forEach(publish => {
                publish.track.enable();
                this.isVideo = true;
            })
        }


    };
    //note
    openNote() {
        this.showNote = true
    }
    /**
     * Note info method for doctor is write some notes during 
     * conversion and save that notes.
     * @param obj 
     */
    noteInfo(obj) {
        this.doctorservice.takeNote(obj).subscribe((data: any) => {
            if (data.status == 'true') {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    customClass: {
                        popup: 'colored-toast'
                    },
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true

                })
                Toast.fire({
                    icon: 'success',
                    title: 'Saved in Successfully'
                })
            }
        })
    }

    //Remote Participant
    /**
     * This method for whom joining as participant(doctor/patient).
     * Their infomation gather and join to define room.
     *  how we create local participant here same as
     * @param participant 
     */
    add(participant: RemoteParticipant) {
        if (this.Rparticipants && participant) {
            this.Rparticipants.set(participant.sid, participant);
            this.registerParticipantEvents(participant);
        }
    }

    remove(participant: RemoteParticipant) {
        if (this.Rparticipants && this.Rparticipants.has(participant.sid)) {
            this.Rparticipants.delete(participant.sid);
        }
    }

    clear() {
        if (this.Rparticipants) {
            this.Rparticipants.clear();
        }
    }

    get participantCount() {
        return !!this.Rparticipants ? this.Rparticipants.size : 0;
    }

    get isAlone() {
        return this.participantCount === 0;
    };


    initialize(participants: Map<Participant.SID, RemoteParticipant>) {
        this.Rparticipants = participants;


        if (this.Rparticipants) {
            this.Rparticipants.forEach(participant => this.registerParticipantEvents(participant));
        }
    };


    private registerParticipantEvents(participant: RemoteParticipant) {
        if (participant) {
            let k = participant.tracks.forEach(publication => this.subscribe(publication));

            participant.on('trackPublished', publication => this.subscribe(publication)

            );
            participant.on('trackUnpublished',
                publication => {
                    if (publication && publication.track) {
                        this.detachRemoteTrack(publication.track);
                    }
                });
        }
    }

    private subscribe(publication: RemoteTrackPublication | any) {
        if (publication && publication.on) {
            publication.on('subscribed', (track: RemoteTrack) => {
                this.attachRemoteTrack(track)
            });
            publication.on('unsubscribed', (track: RemoteTrack) => {
                this.detachRemoteTrack(track);
            });
        }
    }

    private attachRemoteTrack(track: RemoteTrack) {
        if (this.isR_Attachable(track)) {
            const element = track.attach(this.remoteVideo.nativeElement);
        }
    }

    private detachRemoteTrack(track: RemoteTrack) {
        if (this.isR_Detachable(track)) {
            track.detach().forEach(el => el.remove());
        }
    }

    private isR_Attachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
        return !!track &&
            ((track as RemoteAudioTrack).attach !== undefined ||
                (track as RemoteVideoTrack).attach !== undefined);
    }

    private isR_Detachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
        return !!track &&
            ((track as RemoteAudioTrack).detach !== undefined ||
                (track as RemoteVideoTrack).detach !== undefined);
    }


}